/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: b33bb4d6c655
 */

import * as z from "zod";
import { FolderNamePath, FolderNamePath$zodSchema } from "./foldernamepath.js";

export type MoveFolderResponse = { from: FolderNamePath; to: FolderNamePath };

export const MoveFolderResponse$zodSchema: z.ZodType<MoveFolderResponse> = z
  .object({
    from: FolderNamePath$zodSchema,
    to: FolderNamePath$zodSchema,
  });
